import {
  Dialog as MaterialDialog,
  DialogContent as MaterialDialogContent,
  DialogTitle as MaterialDialogTitle,
} from '@material-ui/core';
import { DialogProps } from '@material-ui/core/Dialog';
import React from 'react';
import {
  BackgroundProps,
  ResponsiveWidthValue,
  SpaceProps,
  height,
  maxWidth,
  background as styleBackground,
  maxHeight as styleMaxHeight,
  space as styleSpace,
  width,
} from 'styled-system';
import { SizingProps } from '~frontend-common/lib/styled-components';
import { styled } from '~ui-kit/styled-components';

interface StyledMaterialUIDialogProps extends DialogProps, Omit<SizingProps, 'maxWidth'>, SpaceProps {
  // Background color of the dialog wrapper
  backdropBackgroundColor?: string;
  $maxWidth?: ResponsiveWidthValue;
}

/** @deprecated Use ~ui-kit/components/dialog instead */
export const StyledMaterialUIDialog: React.FunctionComponent<StyledMaterialUIDialogProps> = ({
  backdropBackgroundColor,
  ...props
}) => {
  return (
    <StyledMaterialDialog
      {...props}
      classes={{ paper: 'custom-paper-root' }}
      BackdropProps={{ style: { backgroundColor: backdropBackgroundColor } }}
    />
  );
};

const StyledMaterialDialog = styled(MaterialDialog)<{ $maxWidth?: ResponsiveWidthValue }>`
  .custom-paper-root {
    ${(props) => props.$maxWidth && maxWidth(props.$maxWidth)}
    ${width};
    ${height}
    ${styleSpace};
    ${styleMaxHeight};
    ${styleBackground};
  }
`;

export const StyledMaterialUIContent = styled(MaterialDialogContent)<SpaceProps & SizingProps>`
  && {
    padding-bottom: 24px;
    ${styleSpace};
    ${styleMaxHeight};
  }
`;

export const StyledMaterialUITitle = styled(MaterialDialogTitle)<SpaceProps & BackgroundProps>`
  && {
    ${styleSpace};
    ${styleBackground};
  }
`;
